<ng-container *ngIf="canPublish">
  <button type="button" class="btn btn-success me-2" (click)="publishChangesToRepository()" [disabled]="!canPublish">
    Publish Changes
  </button>
</ng-container>
